import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { SessionQuery } from '@app/core/state/session';
import { RightUtil } from '@app/core/util/right.util';

@Injectable({
  providedIn: 'root'
})
export class MaklerAgbGuard implements CanActivate {
  constructor(private sessionQuery: SessionQuery,
              private rightUtil: RightUtil,
              private snackbar: MatSnackBar,
              private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree{

    const loggedInUser = this.sessionQuery.getLoggedInUser();
    if (loggedInUser?.flags?.maklerVereinbarungNeeded && !loggedInUser?.flags?.maklerVereinbarungAccepted) {

      return this.router.createUrlTree(['/login'],
        { queryParams: { routeAfterLogin: state.url, makleragbnotaccepted: true }});
    }
    return true;
  }
}
